import { render, staticRenderFns } from "./SparePartsTable.vue?vue&type=template&id=5761626a&scoped=true"
import script from "./SparePartsTable.vue?vue&type=script&lang=ts"
export * from "./SparePartsTable.vue?vue&type=script&lang=ts"
import style0 from "./SparePartsTable.vue?vue&type=style&index=0&id=5761626a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5761626a",
  null
  
)

export default component.exports